import { axiosInstance } from "../axios";
import { CAKey, RequestResponse, ResourceFetchParams, Scheme } from "../types";

export const getCAKeys: (
  params: ResourceFetchParams
) => Promise<RequestResponse<{ keys: CAKey[]; count: number }>> = async ({
  pageNumber,
  pageSize
}) => {
  try {
    const response = await axiosInstance.get(
      `/ca-key/get-all-keys?page=${pageNumber}&size=${pageSize}`
    );
    return {
      error: false,
      data: {
        keys: response.data?.content || [],
        count: response.data?.count || 0
      }
    };
  } catch (err) {
    console.error("Unable to get CA keys: ", err.response?.data || err);
    return {
      error: true,
      message: err.response?.data?.responseMessage || err.message,
      data: null
    };
  }
};

export const createCAKey: (payload: {
  scheme: Scheme;
  file: File;
  modulusLength: string;
}) => Promise<RequestResponse> = async ({ scheme, file, modulusLength }) => {
  try {
    const formData = new FormData();
    formData.append("ca-key-file", file);
    formData.append("modulusLength", `${Number(modulusLength) / 8}`);
    await axiosInstance.post(`/ca-key/create?scheme=${scheme}`, formData, {
      headers: {
        "content-type": "multipart/form-data"
      }
    });
    return {
      error: false,
      data: null
    };
  } catch (err) {
    console.error("Unable to create CA key: ", err.response?.data || err);
    return {
      error: true,
      message: err.response?.data?.responseMessage || err.message,
      data: null
    };
  }
};
